import { ChangeEvent, useMemo, useState } from 'react';
import { useBoolean } from 'usehooks-ts';

import { Option } from '@/types/components/common';

export type OptionGroup = {
  name: string;
  order: number;
  items: Option[];
};

export function useSelectLogic(options: Option[]) {
  const [search, setSearch] = useState('');
  const { value: isOpen, setFalse: hide, setTrue: show } = useBoolean();

  const optionByValue: Record<string, Option> = options.reduce(
    (acc, option) => ({
      ...acc,
      ['' + option.value]: option,
    }),
    {},
  );

  const groups = useMemo<OptionGroup[]>(() => {
    const groupByName: Record<string, OptionGroup> = {};
    options.forEach(option => {
      const groupName = option.group || 'undefined';
      if (!groupByName[groupName]) {
        groupByName[groupName] = {
          name: groupName,
          order: option.groupOrder || 0,
          items: [],
        };
      }
      groupByName[groupName].items.push(option);
    });
    const result = Object.values(groupByName);
    result.sort((a, b) => b.order - a.order);
    return result;
  }, [options]);

  const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return {
    search,
    setSearch,
    isOpen,
    hide,
    show,
    optionByValue,
    groups,
    onSearchChange,
  };
}
